import { FromJSONable } from "../../model/FromJSONable";

export interface BookingRequest {
  clave: String;
  fecha: String;
}
export interface FindInvoiceRequest {
  folio: String;
  serie: String;
}

export interface InvoiceFoundRequest{
  
  id:string;
  tipo:string;

}

export interface InvoiceFoundResponse{

  folio:string;
  serie:string;
  archivoBase64:string;
  tipoFile:string;
  
}

export class InvoiceFoundClass implements InvoiceFoundResponse, FromJSONable {
  constructor() {}
  parseJSONObject(object: Object) {
    Object.assign(this, object);
  }
  folio:string;
  serie:string;
  archivoBase64:string;
  tipoFile:string;
}

export interface BookingResponse {
  id: number;
  status: number;
  seats: null;
  persons: Person[];
  etickets_email: string;
  etickets_phone: null;
  etickets_emergency_contact: null;
  etickets_contact_firstName: null;
  etickets_contact_lastName: null;
  booking_code: string;
  booking_amount: string;
  booking_totalamount: string;
  booking_discount: string;
  booking_tax: string;
  travels: null;
  pp: boolean;
  round: boolean;
  classOfService: null;
  routeID: number;
  classID: number;
  observaciones: null;
  escala: Escala[];
}
export interface Escala {
  EscalaID: number;
  VentaID: number;
  ClaveVenta: null;
  ClaveBoleto: null;
  EstacionInicial: number;
  EstacionFinal: number;
  FechaSalida: Date;
  FechaLlegada: Date;
  Tren: Tren;
  TipoRecorrido: number;
  Ruta: Ruta;
  RutaID: number;
}

export interface Ruta {
  RutaID: number;
  EstacionInicialNombre: string;
  EstacionFinalNombre: string;
  FechaSalida: Date;
  HoraSalida: string;
  HoraLlegada: string;
  ClaveOrigen: string;
  ClaveDestino: string;
}

export interface Tren {
  FechaSalida: Date;
  RutaID: number;
  TrenID: number;
  ClaveTren: null;
  Wagons: null;
}

export interface Person {
  id: number;
  id_passenger_type: number;
  name: string;
  lastname: null;
  lastname2: null;
  country: number;
  child: boolean;
  parent_id: number;
  DateofBirth: Date;
}
export class FindInvoiceResponse implements FromJSONable {
  constructor() {}
  parseJSONObject(object: Object) {
    Object.assign(this, object);
  }
  rfc: string;
  razonSocial:string;
  facturaPdf: string;
  facturaXml: string;
}
